import { Suspense } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import MainApp from "./MainApp";
import FullScreenLoader from "./component/loader/Loader";
import AuthGate from "./component/AuthGate";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

const container = document.getElementById("root");

const isTestEnv = process.env.REACT_APP_NODE_ENV === "development";

if (!isTestEnv) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST,
    capture_pageview: "history_change",
    capture_pageleave: "if_capture_pageview",
    autocapture: true,
    defaults: "2026-01-30",
  });
}

if (container) {
  const root = createRoot(container);
  const app = (
    <AuthGate>
      <Suspense fallback={<FullScreenLoader />}>
        {isTestEnv ? (
          <MainApp />
        ) : (
          <PostHogProvider client={posthog}>
            <MainApp />
          </PostHogProvider>
        )}
      </Suspense>
    </AuthGate>
  );
  root.render(app);
} else {
  console.error("Container element with ID 'root' not found.");
}
